/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { instagram } from "../assets/instagram";
import { Icon, type IconBaseProps } from "../icon";

export const IconInstagram = (props: IconBaseProps) => <Icon {...props} svg={instagram} />;

IconInstagram.displayName = "IconInstagram";
